import { useForm } from "react-hook-form";
import { StatutPageSelectorBootstrap } from "../Common/StatutPageSelectorBootstrap";
import { useTrads } from "../../contexts/trads/useTrads";
import type { Pages } from "../../types/Pages";
import { useUpdatePagesMutation } from "../../stores/OkOkStore";

import type { ResponseError } from "../../types/CommonReponse";
import { useEffect } from "react";




function PageManage({page}:{page:Pages}){
    const { register, handleSubmit,setError,formState: { errors } } = useForm({
        defaultValues:page,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const [updatePage, result] = useUpdatePagesMutation();

    const {translate}=useTrads();


    const onSubmit=function(page:Pages){
        return updatePage(page);
    }

    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);


    return (
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <>
        {result.isSuccess ? <p className="p-3 mb-2 bg-success text-white">{translate('modified')}</p> :null}
        {result.error && 'status' in result.error && result.error.status!=400 ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>:null}


        <form className="row" onSubmit={(event) => void handleSubmit(onSubmit)(event)}>

            <StatutPageSelectorBootstrap
                name="statut"
                    label={translate('page_statut')}
                    errors={errors}
                    registerOutput={register("statut", {
                        required: translate("page_error_statut_requis"),
                    })}
            ></StatutPageSelectorBootstrap>
            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        </>
    );
}
export default PageManage;